import type { ClaimFeatureItem, CompareFeatureItem, CompareFeatureItem1vN, ExcelParams, ExcelParams1vN } from '../types';

export const ExportExcelService = Symbol.for('ExportExcelService');

export interface ExportExcelService {
    /**
     * 导出特征拆解结果（无对比）
     * 场景：FeatureExtraction、CompareSetupStep2
     */
    exportClaimExcel(data: ClaimFeatureItem[], tableInfo: ExcelParams): Promise<void>;

    /**
     * 导出 1v1 对比结果
     * 场景：CompareResultPage (1v1 模式)
     */
    exportCompareExcel(data: CompareFeatureItem[], tableInfo: ExcelParams): Promise<void>;

    /**
     * 导出 1vN 对比结果
     * 场景：CompareResultPage (1vN 模式)
     */
    exportCompareExcel1vN(data: CompareFeatureItem1vN[], tableInfo: ExcelParams1vN): Promise<void>;
}